import {hoistCmp, uses} from '@xh/hoist/core';
import {PositionImporterModel} from './PositionImporterModel';
import {button, dialog} from '@xh/hoist/kit/blueprint';
import {Icon} from '@xh/hoist/icon';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import {div, filler, vframe} from '@xh/hoist/cmp/layout';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import './PositionImporter.scss';

export const positionImporter = hoistCmp.factory<PositionImporterModel>({
    model: uses(PositionImporterModel),
    render({model}) {
        return dialog({
            style: {
                width: 600,
                height: 600
            },
            isOpen: model.isOpen,
            onClose: () => model.close(),
            title: 'Position Import',
            icon: Icon.download(),
            item: panel({
                item: vframe(
                    panel({
                        title: 'Transactions',
                        item: grid()
                    }),
                    panel({
                        modelConfig: {
                            side: 'bottom',
                            defaultSize: 150,
                            collapsible: false,
                            resizable: true
                        },
                        title: 'Warnings',
                        compactHeader: true,
                        item: warningList()
                    })
                ),
                bbar: bbar(),
                mask: model.apiTask
            })
        });
    }
});

const warningList = hoistCmp.factory<PositionImporterModel>(({model}) => {
    const warnings = model.warnings.map(warning => div(warning));
    return div({
        className: 'position-importer-warnings',
        items: warnings
    });
});

const bbar = hoistCmp.factory<PositionImporterModel>(({model}) =>
    toolbar(
        filler(),
        button({
            text: 'Cancel',
            onClick: () => model.close()
        }),
        button({
            icon: Icon.check(),
            text: 'Import',
            intent: 'success',
            onClick: () => model.import()
        })
    )
);
